<div mat-dialog-content>
  <p>
    Etes-vous certain de vouloir quitter cette page ?
  </p>
  <p>
    Après confirmation, Le délai de commande étant dépassé, vous ne pourrez plus transmettre votre commande.
  </p>
</div>
<div mat-dialog-actions class="dialog-buttons">
  <button mat-stroked-button (click)="refuse()">Annuler</button>
  <button mat-flat-button color="primary" (click)="confirm()">Confirmer</button>
</div>